import React from "react";
import { LoadingWrapper, Spinner } from "./styles";

const Loading: React.FC = () => {
  return (
    <LoadingWrapper>
      <Spinner />
    </LoadingWrapper>
  );
};

export default Loading;
